module.exports = __webpack_public_path__ + "img/eedchicun.18df00ed.png";